module.exports = __webpack_public_path__ + "img/jotc.29f30748.png";